<template>
  <div class="tw-border-b tw-border-primary-grey-100 tw-pb-4 tw-mb-4">
    <p class="tw-text-lg tw-font-medium">
      {{ t("security-enhancements") }}
    </p>
    <p>{{ t("additional-features") }}</p>
  </div>
  <div
    v-if="isPhishServiceActive || isPhsServiceActive || isSatServiceActive"
    class="tw-mb-4 tw-inline-flex tw-flex-col tw-bg-white tw-p-6 tw-rounded-lg tw-border tw-border-primary-grey-100 tw-w-full"
  >
    <outlook-add-in-card-index />
  </div>
  <div
    v-if="isPhishServiceActive"
    class="tw-mb-4 tw-inline-flex tw-flex-col tw-bg-white tw-p-6 tw-rounded-lg tw-border tw-border-primary-grey-100 tw-w-full"
  >
    <emailSecurityConflictsCardIndex />
  </div>
</template>

<script setup lang="ts">
import outlookAddInCardIndex from "../outlook-add-in-card/outlook-add-in-card.index.vue";
import emailSecurityConflictsCardIndex from "../email-security-conflicts-card/email-security-conflicts-card.index.vue";
import { useI18n } from "vue-i18n";

interface ConnectionsSidebarProps {
  isPhishServiceActive: boolean;
  isPhsServiceActive: boolean;
  isSatServiceActive: boolean;
}

const { t } = useI18n();
defineProps<ConnectionsSidebarProps>();
</script>
